// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221704/js/" + chunkId + "." + {"44":"c4dc2d67","225":"3bde12b9","481":"ad183f28","486":"59e6a362","770":"87fde98c"}[chunkId] + ".0.2817043638425427.chunk.js";
};